<template>
  <div>
    <div ref="form" class="table-biao computer_right_cont_box">
      <div class="thead flex-col">
        <div class="bd11 flex-col">
          <div class="flex-row">
            <span class="td-width td-width-txt left-title">{{ untia }}</span>
            <span
              class="td-width zhongjian"
              v-for="(item, index) in years"
              :key="index"
            >
              <span
                class="td-width-span td-width-txt td-width-txt-first td-width-txt2"
                >{{ item }}</span
              >
              <span class="td-width-span td-width-txt">{{
                $t("FinancialHighlight.Change")
              }}</span>
            </span>
          </div>
        </div>
      </div>
      <div class="table-tbody">
        <div
          class="tbody flex-col"
          v-for="(items, index) in profitablitylist"
          :key="index"
        >
          <div class="bd11 flex-col">
            <div class="flex-row">
              <span class="td-width thead-title left-title">
                {{ items.name }}
                <span></span>
              </span>
              <span
                class="td-width zhongjian"
                v-for="(item, index) in items.lists"
                :key="index"
                v-show="indexlist.includes(index)"
              >
                <el-tooltip
                  :disabled="item.value.length < 8"
                  :content="item.value"
                  placement="top"
                >
                  <span
                    class="td-width-span td-width-txt td-width-txt-first td-width-txt2"
                    >{{ item.value }}</span
                  >
                </el-tooltip>

                <span class="td-width-span td-width-txt table_icon">
                  <span>{{ item.changes == "n.a." ? " " : "" }}</span>
                  <svg
                    t="1718948533724"
                    v-if="item.status == '0' ? true : false"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4505"
                    width="20"
                    height="20"
                  >
                    <path
                      d="M917.7088 491.7248 107.008 491.7248c-11.776 0-21.2992 9.6256-21.2992 21.2992s9.6256 21.2992 21.2992 21.2992l810.7008 0c11.776 0 21.2992-9.6256 21.2992-21.2992S929.3824 491.7248 917.7088 491.7248z"
                      p-id="4506"
                      fill="#bfbfbf"
                    ></path>
                  </svg>
                  <svg
                    t="1718948802984"
                    v-if="item.status == '1'"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="4896"
                    width="16"
                    height="16"
                  >
                    <path
                      d="M512.687 84.864l-261.28 348.26h170.341v509.164h181.866v-509.164h170.341l-261.265-348.26zM512.687 84.864z"
                      fill="#55B419"
                      p-id="4897"
                    ></path>
                  </svg>

                  <svg
                    t="1718948842869"
                    v-if="item.status == '2'"
                    class="icon"
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="5099"
                    width="16"
                    height="16"
                  >
                    <path
                      d="M511.313 939.136l261.28-348.26-170.341 0 0-509.164-181.866 0 0 509.164-170.341 0 261.265 348.26zM511.313 939.136z"
                      fill="#d81e06"
                      p-id="5100"
                    ></path>
                  </svg>
                </span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="createDialog"
      custom-class="dialog_normal"
      @close="Cancel()"
      :append-to-body="true"
    >
      <div class="detail_cont">
        <h3>{{ $t("FinancialHighlight.PleaseSelectTheYeartoDisplay") }}</h3>
        <div class="dialog_detail_next-title">
          {{ $t("FinancialHighlight.SelectUptoThreeYears") }}
        </div>
        <el-checkbox-group v-model="checkedCities" :max="3">
          <el-checkbox-button
            v-for="city in yearslist"
            :label="city"
            :disabled="nodataYears.includes(city) || yearslist.length < 4"
            :key="city"
            >{{ city }}
          </el-checkbox-button>
        </el-checkbox-group>

        <div class="btn_box flex_between_box">
          <!-- <button class="btn_export cansel" @click="Cancel()">
            {{ $t("FinancialHighlight.Cancel") }}
          </button> -->
          <button
            class="btn_export"
            :disabled="checkedCities.length != 3"
            @click="checkYear"
          >
            {{ $t("FinancialHighlight.Select") }}
          </button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    profitablitylist: {
      type: Array,
      default: function () {},
    },
    yearslist: {
      type: Array,
      default: function () {},
    },
    nodataYears: {
      type: Array,
      default: function () {
        return [];
      },
    },
    untia: {
      type: String,
      default: "",
    },
    createDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      indexlist: [0, 1, 2],
      defatindex: 0,
      profitablitylist2: [
        {
          lists: [
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
          ],
          name: "Return on Equity:",
        },
        {
          lists: [
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
          ],
          name: "Return on Assetsd:",
        },
        {
          lists: [
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
            {
              change: "",
              value: "",
            },
          ],
          name: "",
        },
      ],
      // createDialog: true,
      years: ["", "", ""],
      checkedCities: ["", "", ""],
      windows: window,
      moreclose: false,
    };
  },
  created() {},

  watch: {
    $route: {
      handler(val, oldval) {
        this.Indexy = val.path.replace("/", ""); //当前活动路由
      },
      // 深度观察监听
      deep: true,
    },
    profitablitylist: {
      handler(val, oldval) {
        this.profitablitylist = val;
      },
      deep: true,
    },
    nodataYears: {
      handler(val, oldval) {
        this.nodataYears = val;
      },
      deep: true,
    },
    yearslist: {
      handler(val, oldval) {
        this.yearslist = val;
        this.getyears();
      },
      deep: true,
    },
  },
  mounted() {
    this.getyears();
  },

  methods: {
    More() {
      this.moreclose = true;
    },
    closmoreDialog(value) {
      this.moreclose = value;
    },
    diffArray(arr1, arr2) {
      return [
        ...arr1.filter((x) => !arr2.includes(x)),
        ...arr2.filter((x) => !arr1.includes(x)),
      ];
    },
    getyears() {
      if (this.windows.innerWidth > 821) {
        let checkYearArr = this.diffArray(this.yearslist, this.nodataYears);
        if (checkYearArr.length < 3) {
          let nodedateYears = this.nodataYears.slice(
            0,
            3 - checkYearArr.length,
          );
          this.checkedCities = [...checkYearArr, ...nodedateYears];
        } else {
          this.checkedCities = checkYearArr.slice(0, 3);
        }
      }

      var lis = [];
      this.checkedCities.map((item) => {
        lis.push(item);
      });

      this.years = lis.sort(function (a, b) {
        return b - a;
      });
      this.checkYear();
    },
    checkYear() {
      var list = [];
      this.checkedCities.map((item) => {
        list.push(item);
      });

      this.years = list.sort(function (a, b) {
        return b - a;
      });

      this.indexlist = [];
      this.yearslist.map((item, index) => {
        this.checkedCities.map((ite, inde) => {
          if (item == ite) {
            this.indexlist.push(index);
          }
        });
      });
      this.$emit("createDialogcheck", false);
    },
    Cancel() {
      this.$emit("createDialogcheck", false);
    },
  },
};
</script>
<style scoped lang="less">
// 表格
.td {
  margin: 1.0714285714285714rem 0 0 1.7857142857142858rem;
}

.flex-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.rightBox.leftBox {
  display: inline-block;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.changeBox {
  display: flex;
  align-items: center;
}

.thead {
  background: #f2f5f9;
  z-index: 405;
  line-height: 30px;
  padding-right: 20px;
  position: relative;
  border-bottom: 1px solid #cccccc;
}

.tbody {
  z-index: 405;
  padding-right: 20px;
  position: relative;
  border-bottom: 1px solid #cccccc;
}

.thead-img {
  width: 2.142857142857143rem;
  height: 2.142857142857143rem;
  background: #8497ab;
  border-radius: 50%;
  text-align: center;
  line-height: 2.142857142857143rem;
  position: relative;
  top: -0.35714285714285715rem;
}

.td-width {
  // flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 18px;
  color: #1a2332;
  padding: 10px 0 10px 10px;
}

.table-tbody {
  position: relative;
}

.juli {
  margin-left: 2.142857142857143rem;
}

.flex-col {
  display: flex;
  flex-direction: column;
}

.table-biao {
  height: auto;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 0;
  margin-top: 20px;
}

.zhongjian .td-width-txt {
  padding-left: 10px;
}
.zhongjian .table_icon {
  padding-left: 25px;
}
.td-width-span {
  line-height: 34px;
}

.td-width-txt {
  width: 50%;
  white-space: pre-line;
  overflow: hidden;
  text-overflow: ellipsis;
}

.el-checkbox-group {
  // display: flex;
  //   flex-wrap: wrap;
  //   justify-content: space-between;
}

// .el-checkbox {
//     margin-bottom: 1.0714285714285714rem;
//     margin-left: 2.857142857142857rem;
//     margin-right: 0;
// }
/deep/.el-checkbox__label {
  color: #022955ff !important;
}

.el-checkbox__input.is-checked .el-checkbox__inner {
  color: #022955ff !important;
}

/deep/ .el-checkbox-button__inner {
  // border-left: 0.07142857142857142rem solid;
  border: none;
  padding: 0.7142857142857143rem 1.0714285714285714rem;
  font-size: 1.2857142857142858rem;
  color: #1a2332;
  background: #f5f5f5;
  border-radius: 5px;
  width: 8.28571429rem;
}

/deep/ .el-checkbox-button {
  margin-right: 6px;

  margin-bottom: 1rem;
}

/deep/ .el-checkbox-button:nth-of-type(6n + 6) {
  margin-right: 0rem !important;
}

/deep/ .el-checkbox-button:first-child .el-checkbox-button__inner {
  border: none;
}

/deep/ .el-checkbox-button.is-checked .el-checkbox-button__inner {
  background: #ffffff;
  box-shadow: 0rem 0.14285714285714285rem 1rem 0rem rgba(0, 0, 0, 0.12);
  border-radius: 5px;
  font-size: 1.2857142857142858rem;
  color: #1a2332;
  border: 0.07142857142857142rem solid #1290c9;
}

.thead-title {
  display: flex;
  align-items: center;
}

.left-title {
  background: #f2f5f9ff;
  padding-left: 20px;
  width: 240px;
}

.dialog_detail_title {
  font-family: "Arial Bold";
  font-size: 1.4285714285714286rem;
  color: #1a2332;
}

.dialog_detail_next-title {
  font-size: 1rem;
  color: #8497ab;
  line-height: 1.1428571428571428rem;
  text-align: left;
  height: 1.2857142857142858rem;
  margin-top: 0.42857142857142855rem;
  margin-bottom: 1.4285714285714286rem;
}

/deep/ .el-checkbox-button.is-disabled .el-checkbox-button__inner {
  background: #f5f5f5;
  border-radius: 5px;
}

/deep/ .el-checkbox-group {
  font-size: 0;
  display: flex;
  flex-wrap: wrap;
}

.cansel {
  background-color: #8497ab !important;
}
.table-tbody .td-width {
  padding: 14px 0 14px 10px;
}
.td-width.thead-title.left-title {
  line-height: 40px;
}
.td-width-txt-first {
  text-align: right;
}
@media (max-width: 1920px) {
  .table-tbody .td-width-span,
  .table-tbody .td-width {
    line-height: 22px;
  }
  .td-width {
    font-size: 16px;
    padding: 5px 0 5px 10px;
  }
  .table-tbody .td-width {
    padding: 12px 0 12px 10px;
  }
  .td-width.thead-title.left-title {
    line-height: 26px;
  }
  .tbody {
    padding-right: 15px;
  }
  .zhongjian .td-width-txt {
    padding-left: 7px;
  }
  .zhongjian .table_icon {
    padding-left: 18px;
  }
  .table-biao {
    border-radius: 0;
    margin-top: 16px;
  }
}
@media screen and (max-width: 1439px) {
  .td-width {
    font-size: 14px;
    padding: 5px 0 5px 12px;
  }
  .table-tbody .td-width-span,
  .table-tbody .td-width {
    line-height: 20px;
  }
  .table-tbody .td-width {
    padding: 10px 0 10px 10px;
  }
  .td-width.thead-title.left-title {
    line-height: 26px;
  }
  .tbody {
    padding-right: 12px;
  }
  .zhongjian .td-width-txt {
    padding-left: 6px;
  }
  .zhongjian .table_icon {
    padding-left: 16px;
  }
}
</style>
